<script>
import { mapState ,mapActions } from "vuex";
//FF
import IconReconoce from "@/assets/img/icon/section/IconReconoce.vue";
import ReconoceList from "@/components/intranet/reconoce/ReconoceList.vue";
import ModalReconoce from "@/components/intranet/reconoce/ModalReconoce.vue";
import ModalMisReconocimientos from "@/components/intranet/reconoce/ModalMisReconocimientos.vue";
import PaginadorNew from "@/components/layout/PaginadorNew.vue";

export default {
  name: "Reconoce",
  components: {
    //FF
    IconReconoce,
    ReconoceList,
    ModalReconoce,
    ModalMisReconocimientos,
    PaginadorNew
  },
  data() {
    return {
      butonActive: true,
      loading: true,

      visibilityTab: "General",
      //FF
      filter: {
        search: "",
        pagina: 1,
        limite: "20",
        tipo: "1", // "1":General,"2":Recibidos,"3":Enviados
        valor: ""
      },
      // Aplicables sólo en "Mi Muro" (tipo="2" o "3")
      tipos_reconocimientos: [
        { id: "1", label: "General" },
        { id: "2", label: "Recibidos" },
        { id: "3", label: "Enviados" }
      ],
      selected_tipo_reconocimiento: { id: "1", label: "General" },
      detalle_colaborador: {}
    };
  },

  watch: {
    selected_tipo_reconocimiento(newVal) {
      this.filter.tipo = newVal.id;
      if (newVal.id === "2" || newVal.id === "3") {
        this.getTotalReconocimientoPorValor({ tipo_reconocimiento: +newVal.id }); 
      }
    },
    visibilityTab(newVal) {
      if (newVal === "General") {
        this.selected_tipo_reconocimiento = this.tipos_reconocimientos[0];
      } else {
        this.selected_tipo_reconocimiento = this.tipos_reconocimientos[1];
      }
    },
    //FF
    "filter.tipo"() {
      this.filter.pagina = 1;
      this.getReconocimientosPaginaActual();
    },
    "filter.valor"() {
      this.filter.pagina = 1;
      this.getReconocimientosPaginaActual();
    }
  },

  computed:{
    ...mapState("ReconoceModule", [
      "usuario", 
      "reconocimientosPagina", 
      "reconocimientosId", 
      "valoresReconocimientos",
      "totalesReconocimientosPorValor" 
    ]),

    //FF
    colaboradoresFilter() {
      let low = new RegExp(this.filter.search, "i");
      let result = this.reconocimientosPagina.data.filter(element => {
        if (this.filter.tipo === "1" || this.filter.tipo === "2") { /* General || Enviados */
          return low.test(element.reconocidos[0].primer_nombre) || low.test(element.reconocidos[0].apellido_paterno);
        } else if (this.filter.tipo === "3") { /* Recibidos */
          return low.test(element.reconocedor[0].primer_nombre) || low.test(element.reconocedor[0].apellido_paterno);
        } 
      })
      return result;
    },
  },

  async created(){
    await this.getValoresReconoce();
    await this.getUsuario();
    await this.getReconocimientosPaginaActual();
  },

  methods: {
    ...mapActions("ReconoceModule", [
      "getUserActual", 
      "addLikeReconocimiento", 
      "delLikeReconocimiento", 
      "getValoresReconoce", 
      "getReconocimientosPagina",
      "getTotalReconocimientoPorValor"
    ]),
    
    async getUsuario() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
      }
      await this.getUserActual(data_);
    },

    async getReconocimientosPaginaActual() {
      this.loading = true;
      const payload = {
        tipo_reconocimiento: +this.filter.tipo,
        pagina: this.filter.pagina,
        nombre_usuario: ""
      };
      if (this.filter.valor) {
        payload.id_valor = +this.filter.valor.id_valor;
      }
      await this.getReconocimientosPagina(payload);
      this.loading = false;
    },

    //FF
    updatePage(page) {
      this.filter.pagina = page;
      this.getReconocimientosPaginaActual();
    },
    verDetalle(item) {
      this.detalle_colaborador = item;
    },

    // Metodo toggleLikeReconocimiento, realiza la funcionalidad de likes o quitar likes
    async toggleLikeReconocimiento(item) {
      let liked = !!item.confirm_like;
      const payload = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: item.id_reconocimiento,
      }
      if (!liked) {
        await this.addLikeReconocimiento(payload);
      } else {
        await this.delLikeReconocimiento(payload);
      }
    },

  }
};
</script>

<template>
  <section id="reconoce">

    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconReconoce class="me-2 icon-svg-45"/>
          Reconoce
        </h1>
  
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              Reconoce
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 col-lg-8 mb-3 mb-lg-0 d-flex align-items-center">
        <p class="text-secondary h5-custom mb-0">
          ¡Reconoce a tus compañeros! Sé parte de esta iniciativa y mantengamos viva nuestra cultura.
        </p>
      </div>
      <div class="col-12 col-lg-4 text-end">
        <div 
          class="btn-group btn-group-custom" 
          role="group"
        >
          <input 
            value="General"
            v-model="visibilityTab"
            type="radio" 
            class="btn-check btn-group-custom-check" 
            name="filtro-noticias" 
            id="radio-recientes" 
            autocomplete="off" 
            checked
          >
          <label 
            class="btn btn-group-custom-label" 
            for="radio-recientes">
            General
          </label>

          <input 
            value="Mi Muro"
            v-model="visibilityTab"
            type="radio" 
            class="btn-check btn-group-custom-check" 
            name="filtro-noticias" 
            id="radio-mas-vistos" 
            autocomplete="off"
          >
          <label 
            class="btn btn-group-custom-label" 
            for="radio-mas-vistos"
            >
            Mi Muro
          </label>
        </div>     
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div> 

    <div class="row mb-3">
      <div class="col-12 col-lg-3 input-display input-display-left mb-3 m-lg-0">
        <input 
          type="search" 
          class="form-control input-filter" 
          placeholder="Buscar colaborador"
          v-model="filter.search"
        >
        <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="input-display-icon color-gray"></font-awesome-icon>
      </div>
      <div class="col-12 col-lg-3">
        <v-select
          :options="valoresReconocimientos"
          v-model="filter.valor"
          label="nombre_valor"
          placeholder="Selecciona un valor"
          class="vue-select"
        >
        </v-select>
      </div>
      <template v-if="visibilityTab === 'Mi Muro'">
        <div class="col-12 col-lg-3">
          <v-select
            :options="tipos_reconocimientos.slice(1,3)"
            v-model="selected_tipo_reconocimiento"
            placeholder="Selecciona un tipo"
            class="vue-select"
            :clearable="false"
          >
          </v-select>
        </div>
      </template>
      <div 
        class="col-12 d-flex justify-content-end"
        :class="visibilityTab === 'General' ? 'col-lg-6' : 'col-lg-3'"
      >
        <router-link 
          to="/nuevo-reconocimiento"
          class="btn btn-custom btn-custom-main rounded-pill"
        >
          <img
            width="40"
            height="40"
            src="@/assets/img/intranet/reconoce/img-card-reconocer@2x.png"
          />
          Reconoce aquí
        </router-link>
      </div>
    </div>

    <template v-if="visibilityTab === 'Mi Muro'">  
      <div v-if="!loading && colaboradoresFilter.length > 0" class="d-flex align-items-center justify-content-center row">
        <div class="col-12 col-lg-5">
          <div class="card bg-main border-0">
            <div class="card-body pt-0">
              <div class="d-flex justify-content-end">
                <img 
                  height="22" 
                  class="me-5"
                  src="@/assets/img/intranet/reconoce/semicirculo-lineal-gris.svg"
                />
              </div>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <img v-if="usuario.imagen_perfil || /.jpg|.jpeg|.png/.test(usuario.imagen_perfil)"
                        width="70"
                        height="70"
                        class="img-object-cover rounded-circle border border-white p-1"
                        :src="usuario.imagen_perfil"
                      >
                      <img v-else
                        src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                        width="70"
                        height="70"
                        class="img-object-cover rounded-circle border border-white p-1"
                      />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h4 class="d-grid text-white mb-0">
                        <strong class="ellipsis-custom">
                          {{ capitalizeFirstLetter(usuario.primer_nombre) }}
                          {{ capitalizeFirstLetter(usuario.apellido_paterno) }}
                        </strong>
                        <span class="fs-6 text-white text-opacity-75">
                          {{ usuario.cargo[0].nombre_cargo }}
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="flex-shrink-0">
                  <a 
                    href="javascript:"
                    class="btn btn-custom bg-white text-secondary rounded-pill"
                    data-bs-toggle="modal"
										data-bs-target="#modal-mis-reconocimientos"
                  >
                    <img
                      width="40"
                      height="40"
                      src="@/assets/img/intranet/reconoce/img-card-reconocer@2x.png"
                    />
                    Total {{ reconocimientosPagina.count }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="row mt-3">
      <div class="col-12">
        <ReconoceList 
          :reconocimientos="colaboradoresFilter" 
          :loading="loading"
          :tipoReconocimiento="selected_tipo_reconocimiento"
          @verDetalle="verDetalle"
          @toggleLikeReconocimiento="toggleLikeReconocimiento"
        />
      </div>
    </div>

    <PaginadorNew
      v-if="!loading"
      :data="reconocimientosPagina"
      :page="filter.pagina"
      @updatePage="updatePage"
      class="my-3"
    />
    <ModalReconoce :reconocimiento="detalle_colaborador"/> 
    <ModalMisReconocimientos :data="totalesReconocimientosPorValor"/>
  </section>
</template>

